export const authBaseURL = "https://auth.excelmec.org";
export const accountsBaseURL = "https://accounts.excelmec.org";
export const eventsBaseURL = "https://excel-events-backend-7lwulr4nvq-el.a.run.app/api";
export const apiBaseURL = "https://excel-accounts-backend-7lwulr4nvq-el.a.run.app";
